import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs";
import { Pagination } from "../../utils/types/shared/pagination";
import { SmsApiReport } from "../../utils/types/sms/sms-api-report.type";
import { PagedApiResponse } from "../../utils/types/shared/paged-api-response.type";
import { FilterByCompany } from "../../utils/types/reports/sms-report-by-company-filter.type";
import { SMS_TRAFFIC_REPORT_ENDPOINTS } from "../../components/mediaManager/reports/trafic-report/sms-traffic-report.endpoint";
import { DateFilter } from "../../utils/types/core/models/date-filter";
import { SMS_REPORT_ENDPOINTS } from "../../components/mediaManager/reports/sms/components/web-sms-report/sms-report-endpoints";

@Injectable({
    providedIn: "root",
})
export class SmsReportService {
    apiEndPoint = SMS_REPORT_ENDPOINTS;
    trafficReport = SMS_TRAFFIC_REPORT_ENDPOINTS;

    constructor(protected http: HttpClient) {}

    getCampaigns(filters?: any): Observable<any> {
        return this.http
            .post<any>(this.apiEndPoint.list, filters)
            .pipe(map((response) => response));
    }

    getErrorDetails(campaignId: number): Observable<any> {
        return this.http
            .get<any>(
                this.apiEndPoint.error_list.replace(
                    "{id}",
                    campaignId.toString()
                )
            )
            .pipe(map((response) => response));
    }

    getErrorDetailForCompany(data: any): Observable<any> {
        return this.http
            .post(this.trafficReport.error_list_company, data)
            .pipe(map((response) => response));
    }

    getReportByCampaignIdDetail(data: any, filter: any): Observable<any> {
        let params = new HttpParams();

        if (filter !== undefined && filter !== null) {
            params = params.append("limit", filter.limit);
            params = params.append("offset", filter.offset);
        }

        let body = {
            fromDate: data.initialDate,
            toDate: data.finalDate,
        };

        const test = this.http
            .post(
                this.apiEndPoint.getReportsCampaignDetailed.replace(
                    "{id}",
                    data.campaignId
                ),
                body,
                { params }
            )
            .pipe(map((res) => res));

        console.log("LOG SERVICE RES", test);

        return test;
    }

    getSummaryByCampaignIdDetail(data: any): Observable<any> {
        const test = this.http
            .get(
                this.apiEndPoint.getSummaryCampaignDetails.replace(
                    "{id}",
                    data.campaignId
                )
            )
            .pipe(map((res) => res));

        return test;
    }

    getReportSmsApi(
        data: any,
        filter?: Pagination
    ): Observable<PagedApiResponse<SmsApiReport>> {
        let params = new HttpParams();

        if (filter.limit !== undefined && filter.offset !== undefined) {
            params = params.append("limit", filter.limit);
            params = params.append("offset", filter.offset);
        }

        return this.http.post<PagedApiResponse<SmsApiReport>>(
            this.apiEndPoint.getsmsApiReport,
            data,
            {
                params,
            }
        );
    }

    getReportSmsCampaignByCompany(filters: FilterByCompany) {
        return this.http.post(
            this.trafficReport.getsmscampaignByCompany,
            filters
        );
    }

    getMetricsByCarrier(filters: DateFilter): Observable<any> {
        return this.http.post(this.trafficReport.getMetricsByCarrier, filters);
    }

    getMetricsByShortCode(filters: DateFilter): Observable<any> {
        return this.http.post(
            this.trafficReport.getsmsshortcodeMetrics,
            filters
        );
    }

    // getApiMetricsExcel(filters: any) {
    //     return this.http.post(this.apiEndPoint.getSmsApiReportExcel, filters);
    // }

    getApiMetricsExcel(filters: any) {
        return this.http.post(this.apiEndPoint.genSmsApiReportExcel, filters);
    }
}
